import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { DriverDialog } from 'src/modules/supply_chain/components/DriverDialog'
import { skuit } from 'src/services/skuit'

import { DriverListTable } from 'src/components/Table/list/Driver'
import { ListPage } from 'src/components/Pages/ListPage'

export const DriverListPage = () => {
  const paginator = useQueryPaginator(
    'driver-list',
    skuit.sc.drivers.list
  )

  const exportFields = [
    'dl_expires_on',
    'dl_number',
    'dl_state_code',
    'email',
    'first_name',
    'guid',
    'last_name',
    'phone',
  ]

  return (
    <ListPage
      title='Drivers'
      paginator={paginator}
      dialogs={[{ title: 'New Driver', Dialog: DriverDialog }]}
    >
      <DriverListTable
        paginator={paginator}
        fields={['profile', 'dlStateCode', 'dlExpiresOn']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.drivers.export
        }}
      />
    </ListPage>
  )
}
